import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { API_ENDPOINT } from '../../index';
import {
    _testDeliveries,
    _getDeliveryColors,
    _addDeliveryColors,
    _tagDeliveryColors,
    _deleteDeliveryColor
} from '../../services';
import {
    Row,
    Col,
    Popover,
    Button,
    Popconfirm,
    DatePicker,
    Input,
    Dropdown,
    Menu,
    Icon,
    Tooltip,
    message,
} from 'antd'

import SendToLockerButton from './send-to-locker-button';
import AssignToModal from './assign-to-modal';

class ControlButtons extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            toggleDropdown: false,
            addColor: false,
            selectedColor: null,
            colorDescription: "",
            possibleColors: [ 
                // '#e6194b', //red
                // '#3cb44b', //green
                '#ffe119', //yellow
                // '#4363d8', //blue
                '#f58231', //orange
                '#911eb4', //purple
                '#46f0f0', //cyan
                '#f032e6', //magenta
                '#bcf60c', //lime
                '#fabebe', //pink
                '#008080', //teal
                '#e6beff', //lavender
                '#9a6324', //brown
                '#fffac8', //beige
                '#800000', //maroon
                '#aaffc3', //mint
                '#808000', //olive
                '#ffd8b1', //apricot
                '#000075', //navy
                '#808080', //grey
                '#000000', //black
            ],

            restrictedColors: {
                "#ffa39e" : "Rejected",
                "#95de64": "Completed",
                "#69c0ff": "Planned"
            },

            //data fetch
            colors: {},

            assignToModalVisible: false,
        }
    } 

    render(){

        let menu = (
            <Menu selectable={false} style={{width:"30vw", height:"40vh", overflow:"auto"}}>
                {
                    !this.state.addColor &&
                    this.state.colors &&
                    Object.keys(this.state.colors).length > 0 &&
                    Object.keys(this.state.colors).map(_color=>
                        <Menu.Item key={_color} >
                            <Row gutter={16} style={{padding:"5px"}} type="flex" justify="space-between" align="middle">
                                <Col span={14} >
                                    <Row type="flex" justify="start" align="middle" >
                                        <Col style={{marginLeft:"5px"}} >
                                            <div style={{ height:"25px" , width:"25px" , border:"1px black solid", borderRadius:"2px" , backgroundColor:`${_color}`}} />
                                        </Col>
                                        <Col style={{marginLeft:"5px"}} >
                                            { this.state.colors[_color] }
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={10}>
                                    <Row type="flex" justify="center" align="middle">

                                        <Col>
                                            <Button 
                                                type="primary"
                                                icon="plus" 
                                                onClick={()=>this.tagColor(_color, "add")} 
                                            />
                                        </Col>

                                        <Col style={{marginLeft:"5px"}}>
                                            <Button 
                                                type="primary" 
                                                icon="minus" 
                                                onClick={()=>this.tagColor(_color, "delete")} 
                                            />
                                        </Col>

                                        {
                                            (this.props.user.permissions.ezSuperuser ||
                                            this.props.user.permissions.ezDelivery) &&
                                            <Col style={{marginLeft:"10px"}}>
                                                <Popconfirm
                                                    overlayStyle = {{ zIndex:"9999" }}	
                                                    placement = "top"
                                                    title="Are you sure? This will delete the color from ALL DELIVERIES!!!!!"
                                                    onConfirm={()=>this.deleteColorEntry(_color)}
                                                    okText="CONFIRM"
                                                    cancelText="No"
                                                >
                                                    <Button 
                                                        style={{zIndex:"1"}}
                                                        type="danger"
                                                        icon="delete" 
                                                    />
                                                </Popconfirm>
                                            </Col>
                                        }
                                    </Row>
                                </Col>
                            </Row>
                        </Menu.Item>
                    )
                }
                {
                    this.state.addColor &&
                        <Col type="flex" justify="space-around">
                            <Row style={{padding:"5px"}}  type="flex" justify="start" align="middle" >
                                {
                                    this.state.possibleColors.map(_color=>
                                        <Col key={_color}  type="flex" justify="center" align="middle" style={{margin:"10px"}} >
                                            <Button 
                                                onClick={()=>this.addColor(_color)} 
                                                style={{
                                                    backgroundColor:`${_color}`,
                                                    borderRadius: "4px",
                                                    border: ` 2px solid ${ this.state.selectedColor === _color ? "black" : _color }`
                                                }} 
                                            />
                                        </Col>
                                    )
                                }
                            </Row>
                            <Row style={{padding:"5px"}} type="flex" justify="center" align="middle">
                                <Col style={{marginRight: "5px" }} >
                                    <div style={{ height:"25px" , width:"25px" , border:"1px black solid", borderRadius:"2px" , backgroundColor:`${this.state.selectedColor ? this.state.selectedColor : "#ffff" }`}} />
                                </Col>
                                <Col>
                                    <Input style={{width:"20vw"}} value={this.state.colorDescription} placeholder="Description" onChange={this.addColorDescription}  />
                                </Col>
                            </Row>
                        </Col>
                    
                }



                <Menu.Item style={{height:"30px"}} >
                    {
                        this.state.addColor ?
                        <Row type="flex" justify="space-around" align="middle" >
                            <Button 
                                style={{width:"100%",margin:"5px"}} 
                                onClick={this.onSaveColor} 
                                icon="save"
                                type="primary"
                            > 
                                Save
                            </Button>
                        </Row>
                        :
                        <Row type="flex" justify="space-around" align="middle" >
                            {
                                (this.props.user.permissions.ezSuperuser ||
                                this.props.user.permissions.ezDelivery) &&
                                <Button 
                                    style={{width:"100%",margin:"5px"}}
                                    onClick={this.toggleAddColor} 
                                    type="dashed"
                                    size="large"
                                    icon="plus" 
                                />

                            }
                        </Row>
                    }
                    
                </Menu.Item>
          </Menu>
        ) 

        return(
            <Row style={{position:'fixed', zIndex:'999',bottom:'5px', width:'70vw'}} type="flex" justify="start" align="middle">
                
                <Button style={{margin:"5px"}} icon='car' onClick={()=>this.props.toggleOptimizedMode()} size='large' type={this.props.toggleOptimizedRouteMode ? 'danger' : 'default'}/>
                
                <Popover
                    visible = {this.props.datePickerPopover}
                    placement="top"
                    trigger="click"
                    content={
                        <div>
                            <DatePicker
                                size="large"
                                format="DD/MM/YYYY"
                                placeholder="Select Date and Time"
                                value = {this.props.scheduledDate}
                                onChange = {this.props.onChangeDate}
                            />
                            <Button style={{margin:"5px"}} onClick={this.props.changeDateScheduled}>
                                OK
                            </Button>
                        </div>
                    }
                >
                    <Button style={{margin:"5px"}} size='large' type='danger' onClick={(e)=>this.props.toggleDatePicker(e)} >Change Date</Button>
                </Popover>

                {this.state.assignToModalVisible && <AssignToModal 
                    visible={this.state.assignToModalVisible}
                    onCancel={() => this.setState({ assignToModalVisible: false }) }
                    changeDeliveryMode={this.props.changeDeliveryMode}
                    
                    selectedLocationsData = { this.props.selectedLocationsData }
                    selectedLocations = { this.props.selectedLocations }
                    />}

                <Button style={{margin:"5px"}} type='primary' size='large' onClick={this.toggleAssignModalVisible}>Assign To</Button>
                
                <SendToLockerButton selectedLocationsData={this.props.selectedLocationsData}/>

                <Button style={{margin:"5px"}} onClick={this.props.onToggleSelectSupplierModal} size='large' type='danger'>
                    Assign to Supplier Send
                </Button>
                
                <Popconfirm
                    title={`Confirm completion of ${this.props.selectedLocationsData.length} locations?`}
                    onConfirm={()=>this.props.completeSelectedLocations()}  //require cartId products date
                    okText="Yes"
                    cancelText="No"
                >
                    <Button style={{margin:"5px"}} size='large' type='danger' > Complete Selected </Button>
                </Popconfirm>
                <Button 
                    disabled={this.props.selectedLocationsData.length > 1}
                    style={{margin:"5px"}}
                    size='large' 
                    type='danger'
                    onClick={()=>this.props.toggleRejectModal()}
                >
                    Reject
                </Button>

                {/* <Button 
                    disabled={this.props.selectedLocationsData.length > 1}
                    style={{margin:"5px"}}
                    size='large' 
                    type='danger'
                    onClick={()=>this.props.togglePerProductModal()}
                >
                    Per Product Actions
                </Button> */}
                <Button 
                    style={{margin:"5px"}} 
                    icon='lock' 
                    size='large' 
                    type="primary" 
                    onClick={()=>this.props.lockAll(null, null, true)}
                >
                    Mark as planned
                </Button>
                <Button 
                    disabled={this.props.selectedLocationsData.length > 1}
                    icon='edit' 
                    style={{margin:"5px"}} 
                    size='large' 
                    type='primary'
                    onClick = {()=>this.props.toggleEditAddressModal(this.props.selectedLocationsData[0]._id , this.props.selectedLocationsData[0].address)}
                >
                    Edit Address
                </Button>
                <Button style={{margin:"5px"}} type="primary" size="large" onClick={this.props.tckEndpoint}>
                    Check TCK
                </Button>
                
                

                <Dropdown 
                    visible={this.state.toggleDropdown} 
                    trigger="click" 
                    overlay={menu} 
                    placement="topCenter"
                    style={{width:"30vw"}}
                >
                    <Button.Group style={{margin:"5px"}} >
                        <Tooltip title={this.renderTooltip}>
                            <Button size="large" icon="info-circle" type="dashed"/>
                        </Tooltip>
                        <Button type="primary" size="large" onClick={this.toggleDropdown}>
                            Assign color
                        </Button>
                    </Button.Group>
                </Dropdown>

                <Popconfirm
                    title={`Confirm deletion of ${this.props.selectedLocationsData.length} locations?`}
                    onConfirm={()=>this.props.deleteSelectedLocations()}  //require cartId products date
                    disabled={!(this.props.selectedLocationsData.length === 1)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button style={{margin:"5px"}} 
                        size='large' 
                        type='danger' 
                        disabled={!(this.props.selectedLocationsData.length === 1)}
                    > Delete 1 Selected </Button>
                </Popconfirm>

            </Row>
        )
    } 

    componentDidMount(){
        _getDeliveryColors()
        .then(res=>{
            this.setState({
                colors: res.data
            })
        })
    }

    renderTooltip = () => {
        return(
            <Col type="flex" justify="space-around" align="middle">
                {
                    this.state.colors &&
                    Object.keys(this.state.colors).length > 0 &&
                    Object.keys(this.state.colors).sort().map(_color=>
                        <Row gutter={16} style={{padding:"5px"}} type="flex" justify="space-around" align="middle">
                            <Col span={4} >
                                <div style={{ height:"25px" , width:"25px" , border:"1px black solid", borderRadius:"2px" , backgroundColor:`${_color}`}} />
                            </Col>
                            <Col span={20} >
                                { this.state.colors[_color] }
                            </Col>
                        </Row>
                    )
                }
                {
                    Object.keys(this.state.restrictedColors).sort().map(_color=>
                        <Row gutter={16} style={{padding:"5px"}} type="flex" justify="space-around" align="middle">
                            <Col span={4} >
                                <div style={{ height:"25px" , width:"25px" , border:"1px black solid", borderRadius:"2px" , backgroundColor:`${_color}`}} />
                            </Col>
                            <Col span={20} >
                                { this.state.restrictedColors[_color] }
                            </Col>
                        </Row>
                    )
                }
                
            </Col>
        )
    }

    deleteColorEntry = (color) => {
        _deleteDeliveryColor(color)
        .then(()=>{
            _getDeliveryColors()
                .then((res)=>{
                    this.setState({
                        colors: res.data,
                        toggleDropdown: false
                    }, this.props.refreshPage)
                })
        })
    }

    toggleAddColor = () =>{
        this.setState({
            addColor: !this.state.addColor
        })
    }
    toggleDropdown = () => {

        if( !this.state.toggleDropdown ){
            this.setState({
                toggleDropdown: true
            })
        }else{
            this.setState({
                toggleDropdown: false,
                selectedColor: null,
                colorDescription: "",
                addColor: false
            })
        }
        
    }
    toggleAssignModalVisible = () => {
        this.setState({
            assignToModalVisible: !this.state.assignToModalVisible
        })
    }
    addColor = (color) => {

        this.setState({
            selectedColor: color,
            colorDescription: this.state.colors[color] || ""
        })
    }
    addColorDescription = (e) => {
       
        this.setState({
            colorDescription: e.target.value
        })
    }
    onSaveColor = () => {

        let{
            selectedColor,
            colorDescription
        } = this.state

        if(!this.state.selectedColor){

            message.error("Select color")

        }else{

            _addDeliveryColors({
                color: selectedColor,
                description: colorDescription
            })
            .then(()=>{
                _getDeliveryColors()
                .then((res)=>{
                    this.setState({
                        colors: res.data,
                        addColor: false
                    })
                })
            })
        } 
        
    }
    tagColor = (color, action) => {
        _tagDeliveryColors({
            color,
            action: action,
            idArray: this.props.selectedLocations,
            userName: this.props.user.details.name,
            userEmail: this.props.user.details.email,
            userId: this.props.user._id,
            colorDesc: this.state.colors[color]
        })
        .then(()=>{
            this.setState({
                toggleDropdown: false,
                selectedColor: null,
                colorDescription: "",
                addColor: false
            }, this.props.refreshPage)
        })
    }

    bryceTest = () =>{
        _testDeliveries()
    }
    

    shouldComponentUpdate(nextProps, nextState){

        if( nextState.colors !== this.state.colors ){
            return true
        }
        if( nextState.toggleDropdown !== this.state.toggleDropdown ){
            return true
        }
        if( nextState.addColor !== this.state.addColor ){
            return true
        }
        if( nextState.selectedColor !== this.state.selectedColor ){
            return true
        }
        if( nextState.colorDescription !== this.state.colorDescription ){
            return true
        }
        if( nextState.assignToModalVisible !== this.state.assignToModalVisible ){
            return true
        }

        let currentSelected = this.props.selectedLocations.map(a=>a._id)
        let incomingSelected = nextProps.selectedLocations.map(a=>a._id)
        if( currentSelected.sort().join() !== incomingSelected.sort().join() ){
            return true
        }

        if( this.props.toggleOptimizedRouteMode !== nextProps.toggleOptimizedRouteMode ){
            return true
        }

        if( this.props.scheduledDate !== nextProps.scheduledDate ){
            return true
        }
        
        if( this.props.datePickerPopover !== nextProps.datePickerPopover ){
            return true
        }

        if( moment(this.props.selectedLocationsData).format("YYYY-MM-DD") != moment(nextProps.selectedLocationsData).format("YYYY-MM-DD") ){
            return true
        }
        return false
    }



}
export default ControlButtons;


// WEBPACK FOOTER //
// ./src/components/delivery-page/ControlButtons.js